<template lang="">
  <div id="home_page">
    <div class="h_banner">
      <swiper v-if="bannerList.length>0" :options="newSwiper" class="swiper_banner">
        <swiper-slide class="swiper_banner_slide" v-for="(item,index) in bannerList" :key="item.id">
          <img @load="onImageLoad" :src="item.pic" alt="">
        </swiper-slide>
      </swiper>
      <div v-else style="height: 100vh;">
      </div>
      <div class="dot">
        <span v-for="(item,index) in bannerList" :key="index"></span>
      </div>
    </div>
    <div class="h_container">
      <div class="h_content">
        <div class="h_c_top">
          <img style="" src="@/assets/img/red_icon.png" alt="">
          <span style="">活动板块</span>
          <div class="h_c_background">
            <div>ACTIVE PLATE</div>
            <div style="display: flex; align-items: center;">
              <ul>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
              <!-- <img src="@/assets/img/good.png" alt=""> -->
              <img :src="siteList.side_logo || '@/assets/img/good.png'" alt="">
            </div>
          </div>
        </div>
        <div class="h_c_plate">
          <div class="h_c_left">
            <ul>
              <li @mouseenter="setActive(1)" @mouseleave="remove(1)"
                :class="{ active: activeIndex === 1||$route.query.status==1}">
                <router-link :to="{path:'/',query:{status:1}}">活动预告</router-link>
                <div></div>
              </li>
              <li @mouseenter="setActive(2)" @mouseleave="remove(2)"
                :class="{ active: activeIndex === 2||$route.query.status==2 }">
                <router-link :to="{path:'/',query:{status:2}}">正在进行</router-link>
                <div></div>
              </li>
              <li @mouseenter="setActive(3)" @mouseleave="remove(3)"
                :class="{ active: activeIndex === 3||$route.query.status==3 }">
                <router-link :to="{path:'/',query:{status:3}}">活动回顾</router-link>
                <div></div>
              </li>
            </ul>
          </div>
          <div class="h_c_right">
            <ul class="f_ul" data-aos="fade-up">
              <li data-aos="fade-up" v-for="(item,index) in activityList.slice(0,3)" :key="item.id">
                <router-link :to="{path:'/news/detail',query:{id:item.id}}">
                  <el-image class="h_c_tupian" :src="item.small_pic" alt="" lazy></el-image>
                  <div class="h_c_shadow">
                    <div class="h_c_date">
                      <div>{{item.publish_time[2]}}</div>
                      <div>{{item.publish_time[0]}}.{{item.publish_time[1]}}</div>
                    </div>
                    <div class="h_c_title">
                      <span>{{item.title}}</span>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
            <ul class="s_ul">
              <div class="s_ul_pic" data-aos="zoom-out-up" v-for="(item,index) in activityList.slice(3,4)"
                :key="item.id">
                <router-link :to="{path:'/news/detail',query:{id:item.id}}">
                  <img :src="item.small_pic" alt="">
                  <div>
                    <div class="h_c_date">
                      <div>{{item.publish_time[2]}}</div>
                      <div>{{item.publish_time[0]}}.{{item.publish_time[1]}}</div>
                    </div>
                    <div class="h_c_title">
                      <span>{{item.title}}</span>
                    </div>
                  </div>
                </router-link>
              </div>
              <div class="s_ul_right">
                <ul>
                  <li data-aos="zoom-in-left" v-for="(item,index) in activityList.slice(4,8)" :key="item.id">
                    <router-link :to="{path:'/news/detail',query:{id:item.id}}">
                      <img :src="item.small_pic" alt="">
                      <div>
                        <div class="h_c_title">
                          <span>{{item.title}}</span>
                        </div>
                        <div class="h_c_date">
                          <div>{{item.publish_time[0]}}-{{item.publish_time[1]}}-{{item.publish_time[2]}}</div>
                        </div>
                      </div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </ul>
            <ul class="t_ul">
              <li data-aos="fade-up" v-for="(item,index) in activityList.slice(8,12)">
                <router-link :to="{path:'/news/detail',query:{id:item.id}}">
                  <img :src="item.small_pic" alt="">
                  <div>
                    <div class="h_c_title">
                      <span>{{item.title}}</span>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['siteList'],
    data() {
      return {
        activeIndex: 1,
        status: 1,
        bannerList: [],
        activityList: [],
        newSwiper: {
          loop: true,
          speed: 2000,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },
          pagination: {
            el: ".dot",
            clickable: true
          },
        },
        imageLoaded: false
      }
    },
    created() {
      this.getBanner()
      this.getActivity()
    },
    watch: {
      '$route.query.status'(newVal, oldVal) {
        this.getActivity()
      }
    },
    mounted() {
      // 如果需要，可以在组件挂载时重新初始化 AOS
      setTimeout(() => {
        this.$aos.refresh();
      }, 1500)
    },
    methods: {
      onImageLoad() {
        this.imageLoaded = true;
      },
      async getBanner() {
        let res = await this.$request.post('banner/getAll')
        if (res.data.code === 0) {
          this.bannerList = res.data.data
        }
      },
      async getActivity() {
        this.status = this.$route.query.status
        let res = await this.$request.post('activity/getAll', {
          hot: 1,
          type: this.status ? this.status : 1,
        })
        if (res.data.code === 0) {
          this.activityList = res.data.data
          this.activityList.forEach(item => {
            item.publish_time = item.publish_time.split(' ')[0]
            item.publish_time = item.publish_time.split('-')
          })
        }
      },
      setActive(id) {
        this.activeIndex = id;
      },
      remove(id) {
        if (this.activeIndex === id) {
          this.activeIndex = null;
        }
      }
    },
  }
</script>
<style lang="scss" scoped>
  .active {
    a {
      color: #E60012 !important;
    }

    div {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 30px !important;
      height: 2px;
      background-color: #E60012;
    }
  }
</style>